// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"double-storey"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M17 9H20V21H4V9H7V3H17V9Z"},"nodeName":"path","children":[]},{"attributes":{"id":"fill2","fill":"transparent","d":"M9 21V14H15V21H9Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2"},"nodeName":"g","children":[{"attributes":{"stroke":"currentColor","d":"M11.998 5.99805H12.002V6.00195H11.998V5.99805Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"stroke":"currentColor","d":"M9 21V14H15V21H9Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M6 3H7M7 3V9H17V3M7 3H17M17 3H18M3 9H4M4 9V21M4 9H20M4 21H3M4 21H20M20 9V21M20 9H21M20 21H21","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-double-storey')
export default class DoubleStoreyIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'double-storey',
    }
  }
}
